import { cn } from '@cleanlab/design-system/utils'
import { motion } from 'motion/react'
import React from 'react'

interface ShimmerProps {
  width?: string | number
  height?: string | number
  className?: string
}

const Shimmer: React.FC<ShimmerProps> = ({ width = '100%', height = 16, className = '' }) => {
  return (
    <div
      data-testid="shimmer"
      className={cn(`relative overflow-hidden rounded-1 bg-surface-2`, className)}
      style={{ width, height }}
    >
      <motion.div
        className="absolute inset-0 -translate-x-full"
        animate={{
          translateX: ['0%', '100%'],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
          repeatType: 'reverse',
        }}
      >
        <div className="size-full bg-gradient-to-r from-transparent via-surface-1-active to-transparent" />
      </motion.div>
    </div>
  )
}

export default Shimmer
